import axiosInstance from '../utils/axiosConfig';

/**
 * 获取应用配置
 * @param {string} appcode - 应用代码
 * @returns {Promise} - API响应
 */
export const getAppConfig = async (appcode, mode) => {
    try {
        const url = appcode ? `/invoice/app-config?appcode=${appcode}&mode=${mode || ''}` : '/invoice/app-config';
        const response = await axiosInstance.get(url);
        return response.data;
    } catch (error) {
        console.error('Failed to get app config:', error);
        throw error;
    }
};

/**
 * 更新应用配置
 * @param {Object} settingsData - 应用设置数据
 * @param {string} appcode - 应用代码
 * @returns {Promise} - API响应
 */
export const updateAppConfig = async (settingsData, appcode) => {
    try {
        const url = appcode ? `/invoice/app-config?appcode=${appcode}` : '/invoice/app-config';
        const response = await axiosInstance.post(url, settingsData);
        return response.data;
    } catch (error) {
        console.error('Failed to update app config:', error);
        throw error;
    }
}; 